<template>
  <el-form :model="form" ref="formRef" label-width="80px" :inline="false">
    <el-form-item label="邮箱" prop="email" :rules="{ required: true, message: '请输入邮箱', trigger: 'blur' }">
      <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
    </el-form-item>
    <el-form-item label="验证码" prop="code" :rules="{ required: true, message: '请输入验证码', trigger: 'blur' }">
      <el-input v-model="form.code" placeholder="请输入验证码">
        <template slot="append">
          <span
            @click="handleGetCode"
            :class="form.email ? 'active-phone-code phone-code-color' : 'disabled-phone-code'"
            v-if="!timer"
          >
            获取验证码
          </span>
          <span v-else class="disabled-phone-code">
            重新获取
            <span class="phone-code-color">（{{ timer }}）</span>
          </span>
        </template>
      </el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import { getEmailCode } from '@/apis/userInfo'
export default {
  props: {
    value: String,
  },
  data() {
    return {
      form: {
        code: '',
        email: '',
      },
      timer: 0,
      timeInterval: null,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        val && this.$set(this.form, 'email', val)
      },
    },
  },
  methods: {
    handleStartCountTime() {
      this.timer = 60
      this.timeInterval = setInterval(() => {
        if (this.timer <= 0) {
          clearInterval(this.timeInterval)
          return
        }
        this.timer = this.timer - 1
      }, 1000)
    },
    handleGetCode() {
      if (!this.form.email) return
      getEmailCode({
        email: this.form.email,
      }).then((res) => {
        if (res.code === 200) {
          this.handleStartCountTime()
        }
      })
    },
  },
}
</script>
<style scoped>
.active-phone-code {
  cursor: pointer;
}
.disabled-phone-code {
  cursor: not-allowed;
}
.phone-code-color {
  color: #0b6fd6;
}
::v-deep .el-input {
  width: 100%;
}
</style>
